export default "__VITE_ASSET__5689b28f__"